import React from "react";
import styles from "./Campaign.module.css";

import MobileCampaign from "./../../assets/images/data/mobile-campaign.gif";

const showCampaign = false;

const Campaign = () => {
  if (!showCampaign) {
    return null;
  }

  return (
    <div className={styles.Campaign}>
      <img src={MobileCampaign} className={styles.Image} alt="campagin" />
    </div>
  );
};

export default Campaign;
